import gql from 'graphql-tag'
import { User } from '~/graphql/fragments/user.js'

export const GET_NEW_USER_SESSION_TOKEN = gql`
  query NewSessionTokens {
    newSessionTokens {
      userToken
    }
  }
`
export const GET_ACADEMY_LEARNING_JOURNEY = gql`
  query academyLearningJourney($schoolId: Int!) {
    academyLearningJourney(schoolId: $schoolId) {
      addSchoolDetails
      addStaff
      choosePerformanceFramework
      grantTeacherPermission
      completeProfile
      activeLittleAcademy
      enrolledAClass
    }
  }
`
export const GET_LEARNING_STREAK = gql`
  query ($schoolId: Int!, $days: Int) {
    academyUserStreak(schoolId: $schoolId, days: $days) {
      id
      dailyGoalTime
      dayOfWeek
      watchedTime
      reachGoal
      todayDiff
    }
  }
`
export const GET_ACADEMY_USER_PROFILE = gql`
  query ($personalProfileId: Int) {
    academyPersonalProfile(personalProfileId: $personalProfileId) {
      id
      name
      email
      title
      currentStreak
      longestStreak
      academyMinutesPerDay
      roles {
        role {
          name
        }
      }
      allRoles {
        role {
          name
        }
        endDate
        startDate
      }
      manager {
        id
        userId
        name
        media {
          url
        }
      }
      academyMinutesPerDay
      designation
      dateJoin
      qualificationLevels
      yearOfExp
      agesFrom
      agesTo
      nric
      employeeId
      media {
        id
        url
        fileName
      }
      school {
        id
        type
        name
        staffSize
        agesTo
        agesFrom
        website
        address
        population
        schoolProfile {
          email
        }
      }
    }
  }
`

export const GET_USER_PROFILE = gql`
  query academyUserProfile($userId: Int, $schoolId: Int) {
    academyUserProfile(userId: $userId, schoolId: $schoolId) {
      personalProfiles(schoolId: $schoolId) {
        id
        userId
        name
        email
        currentStreak
        longestStreak
        nric
        employeeId
        organisationTitleId
        user {
          ...User
          userRoles {
            startDate
            endDate
            module
            name
            schoolId
          }
        }
        manager {
          id
          userId
          name
          media {
            url
          }
        }
        designation
        dateJoin
        qualificationLevels
        yearOfExp
        agesFrom
        agesTo
        academyMinutesPerDay
        academyActivedAt
        title
        media {
          id
          url
          fileName
        }
        school {
          id
          name
          type
          staffSize
          agesTo
          agesFrom
          website
          address
          population
          parentId
          countryCode
          schoolProfile {
            email
            phone
          }
        }
        courses {
          id
          name
          slug
          cover
          popular
          inMyList
          trainer {
            id
            name
          }
          totalTime
          learnMode
          courseMedias {
            id
            media {
              thumbnail
              id
            }
          }
          topics {
            id
            mediaFromTime
            mediaToTime
          }
        }
      }
      workExperiences {
        id
        title
        organisation
        location
        isHighlight
        isCurrently
        startDate
        endDate
        description
        medias {
          id
          url
          fileName
        }
      }
      trainingRecords {
        id
        courseTitle
        courseProvider
        trainingMode
        startDate
        endDate
        trainingTime
        verifiedAt
        verifiedBy
        verifiedName
        description
        trainingCost
        sponsoredBy
        grantBy
        medias {
          id
          fileName
          url
        }
      }
    }
  }
  ${User}
`
export const GET_USERS_INFO = gql`
  query usersInfo($ids: [Int], $schoolId: Int) {
    usersInfo(ids: $ids, schoolId: $schoolId) {
      ...User
    }
  }
  ${User}
`
export const FOUR_LOGIN = gql`
  mutation FourLogin($jwtToken: String!, $client: String!) {
    fourLogIn(jwtToken: $jwtToken, client: $client) {
      sessionTokens {
        userToken
      }
      errors {
        key
        message
      }
    }
  }
`

export const CHECK_AUTHENTICATION = gql`
  query me {
    me {
      email
      fullName
    }
  }
`

export const GET_USER_ACTIVITY_HISTORIES = gql`
  query userActivityHistories(
    $targetType: UserActivityTargetType
    $schoolId: Int
    $limit: Int
    $page: Int
    $targetId: Int
  ) {
    userActivityHistories(
      targetType: $targetType
      schoolId: $schoolId
      limit: $limit
      page: $page
      targetId: $targetId
    ) {
      data {
        id
        action
        changes
        insertedAt
        targetId
        user {
          fullName
          id
          media {
            url
            fileName
          }
        }
      }
      meta {
        limit
        page
        total
      }
    }
  }
`
